export const MetalBirdBundlePreviewStyles = (
    <style>{`
        #bundlePreviewWrapper {
            max-width: 100% !important;
        }
        #bundlePreviewWrapper div[data-label="Discount Tab"] {
            flex-direction: row;
            align-items: center;
            padding-inline: 12px;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] {
            width: 100%;
            border: 0 !important;
            padding: 15px 8px;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 10px;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] > div {
            border-radius: 0 !important;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] > div > div > div {
            flex-direction: row;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] > div div[data-label="Product Image"] {
            width: 80px !important;
            height: auto !important;
            border-radius: 0 !important;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] > div div[data-label="Product Image"] img {
            border-radius: 4px !important;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] div[data-label="Product Title"] {
            line-height: 1;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] ~ div {
            width: 100% !important;
            margin-top: 0 !important;
            border-radius: 0 !important;
        }
        #bundlePreviewWrapper div[data-label="Product Card"] ~ div button {
            padding: 12px !important;
        }
        @media only screen and (max-width: 635px) {
            #bundlePreviewWrapper div[data-label="MixMatch Bundle Title"] {
                font-size: 15px !important;
            }
            #bundlePreviewWrapper div[data-label="Product Card"] {
                padding: 0;
            }
            #bundlePreviewWrapper div[data-label="Product Card"] > div {
                padding: 0 !important;
            }
            #bundlePreviewWrapper div[data-label="Product Card"] ~ div button {
                padding: 14px 12px !important;
                font-size: 12px !important;
                line-height: 1;
                min-height: 0 !important;
            }
        }
    `}</style>
);
